// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3VHFM","alert":"SettungsInbox_alert__2MqTZ"};